import { Select } from "antd";
import { SelectProps } from "antd/lib";
import React from "react";

export const TaskNameSelect = (props: SelectProps) => {
  return (
    <Select
      {...props}
      options={[
        {
          label: "View",
          options: [
            { label: "Start", value: "TASK_NAME_START" },
            { label: "Track", value: "TASK_NAME_TRACK" },
            { label: "Close", value: "TASK_NAME_CLOSE" },
            { label: "Skip", value: "TASK_NAME_SKIP" },
            { label: "Open", value: "TASK_NAME_OPEN" },
            { label: "Show", value: "TASK_NAME_SHOW" },
            { label: "Hide", value: "TASK_NAME_HIDE" },
            { label: "Progress", value: "TASK_NAME_PROGRESS" },
            { label: "Schedule", value: "TASK_NAME_SCHEDULE" },
            { label: "Lock Visibility", value: "TASK_NAME_LOCK_VISIBILITY" },
            {
              label: "Unlock Visibility",
              value: "TASK_NAME_UNLOCK_VISIBILITY",
            },
            { label: "Show Overlay", value: "TASK_NAME_SHOW_OVERLAY" },
            { label: "Hide Overlay", value: "TASK_NAME_HIDE_OVERLAY" },
            { label: "Notify Open", value: "TASK_NAME_NOTIFY_OPEN" },
            { label: "Simulate Click", value: "TASK_NAME_SIMULATE_CLICK" },
          ],
        },
        {
          label: "Video",
          options: [
            { label: "Mute", value: "TASK_NAME_MUTE" },
            { label: "Unmute", value: "TASK_NAME_UNMUTE" },
          ],
        },
      ]}
    />
  );
};
